import { useMeta, UseMetaProps } from "hooks/useMeta";

export const Meta: React.FC<UseMetaProps> = (props) => {
    useMeta(props);
    return null;
};
